/* @flow */

import getInputPorId from './get-input-por-id';
import previewImagem from './preview-imagem';
import getFileImagemInput from './get-file-imagem-input';

const readInputFile = (file: File): Promise<string | ArrayBuffer> => new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => resolve(reader.result);
});

const getImagemInicial = (inputId: string) => {
    const imagemInicial = document.querySelector(`.${inputId}`);
    return imagemInicial instanceof HTMLImageElement && imagemInicial.src;
};

const inputFileComPreview = (inputId: string) => {
    const input = getInputPorId(inputId);
    const imagemInicial = getImagemInicial(inputId);
    input.onchange = async () => {
        const file = getFileImagemInput(inputId);
        if (!file) {
            input.value = '';
            if (imagemInicial) {
                previewImagem.set(`.${inputId}`, imagemInicial);
            }
            return;
        }

        const result = await readInputFile(input.files[0]);
        if (typeof result === 'string') {
            previewImagem.set(`.${inputId}`, result);
        }
    };
};

export default inputFileComPreview;
